module.exports = __webpack_public_path__ + "static/media/spin-wheel.7fa5a337.png";